<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.amountDetails && _vm.amountDetails.adId
    ? _c("div", { staticClass: "border rounded pr-2 pl-2 pb-2" }, [
        _c("div", { staticClass: "d-flex justify-content-between mt-1" }, [
          _vm.amountDetails.orderType === "BUY"
            ? _c("div", { staticClass: "profile-text" }, [
                _vm._v(" " + _vm._s(_vm.$t("amount.Amount")) + " "),
              ])
            : _vm._e(),
          _vm.amountDetails.orderType === "SELL"
            ? _c("div", { staticClass: "profile-text" }, [
                _vm._v(" " + _vm._s(_vm.$t("amount.Amount")) + " "),
              ])
            : _vm._e(),
          _c("div", { staticClass: "profile-amt-green" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.amountDetails.totalAmount + " " + _vm.amountDetails.fiat
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("div", [
            _c("div", { staticClass: "profile-text" }, [
              _vm._v(_vm._s(_vm.$t("amount.Price"))),
            ]),
          ]),
          _c("div", [
            _c("div", { staticClass: "profile-amt" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.amountDetails.rate + " " + _vm.amountDetails.fiat
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "d-flex justify-content-between mt-1" }, [
          _c("div", [
            _vm.amountDetails.orderType === "BUY" &&
            _vm.amountDetails.orderStatus === "COMPLETED"
              ? _c("div", { staticClass: "profile-text" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("amount.Received-Quantity")) + " "
                  ),
                ])
              : _vm.amountDetails.orderType === "BUY"
              ? _c("div", { staticClass: "profile-text" }, [
                  _vm._v(" " + _vm._s(_vm.$t("amount.Receive-Quantity")) + " "),
                ])
              : _vm._e(),
            _vm.amountDetails.orderType === "SELL"
              ? _c("div", { staticClass: "profile-text" }, [
                  _vm._v(" " + _vm._s(_vm.$t("amount.TotalQuality")) + " "),
                ])
              : _vm._e(),
          ]),
          _c("div", [
            _c("div", { staticClass: "profile-amt" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.user.id !== _vm.amountDetails.adUserId
                      ? _vm.amountDetails.finalQuantity +
                          " " +
                          _vm.amountDetails.coin
                      : _vm.amountDetails.totalQuantity +
                          " " +
                          _vm.amountDetails.coin
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
        _vm.user.id !== _vm.amountDetails.adUserId
          ? _c("div", { staticClass: "d-flex justify-content-between mt-1" }, [
              _c("div", [
                _c("div", { staticClass: "profile-text" }, [
                  _vm._v(_vm._s(_vm.$t("amount.Fee"))),
                ]),
              ]),
              _c("div", [
                _c("div", { staticClass: "profile-amt" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.amountDetails.fee + " " + _vm.amountDetails.coin
                      ) +
                      " "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/amount-section/Amount.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as vuex from 'vuex';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  props: {
    amountDetails: {
      type: Object,
      isRequired: false,
      default: () => {}
    }
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  }
});

//# sourceURL=webpack:///./src/@core/components/amount-section/Amount.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.profile-text {
  color: #686e7d;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt {
  display: flex;
  justify-content: flex-end;
  color: var(--1e2329);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt-green {
  display: flex;
  justify-content: flex-end;
  color: #8dc540;
  font-size: 21px;
  font-weight: 700;
  line-height: 32px;
}
</style>
